export const getFavoritesProducts = (state) => state.favorites.data;
export const favoritesLoading = (state) => state.favorites.isLoading;
  